var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{class:_vm.$vuetify.theme.dark ? undefined : 'grey lighten-3',attrs:{"id":"pages"}},[_c('v-img',{class:{
      'v-image--sm': this.$vuetify.breakpoint.smAndDown,
      'v-image--md': this.$vuetify.breakpoint.mdAndDown
    },attrs:{"src":require(`@/assets/${_vm.src || 'login.jpg'}`),"gradient":"to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)","min-height":"100%"}},[_c('v-responsive',{staticClass:"d-flex align-center",style:(_vm.styles),attrs:{"min-height":"100vh"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }